import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	topNav: {
		defaultMessage: 'Primary',
		id: 'atlassian-navigation.top-nav',
		description:
			'Describes the specific role of this navigation component for users viewing the page with a screen reader. Differentiates from other navigation components on a page.',
	},
});
